import api from "./axios";
import { PermissionInfo, Profile, ProfileRequest, UserProfiles } from "../interfaces/Profile";

/** Catálogo completo de permissões — a matriz da tela é desenhada a partir dele. */
export const getPermissionCatalog = async (): Promise<PermissionInfo[]> =>
  (await api.get("/Profile/permissions")).data;

export const getProfiles = async (): Promise<Profile[]> =>
  (await api.get("/Profile")).data;

export const createProfile = async (body: ProfileRequest): Promise<Profile> =>
  (await api.post("/Profile", body)).data;

export const updateProfile = async (id: number, body: ProfileRequest): Promise<Profile> =>
  (await api.put(`/Profile/${id}`, body)).data;

export const deleteProfile = async (id: number): Promise<void> => {
  await api.delete(`/Profile/${id}`);
};

export const getUserProfiles = async (): Promise<UserProfiles[]> =>
  (await api.get("/Profile/users")).data;

/** Envia o conjunto COMPLETO de perfis do usuário — o que não vier na lista é removido. */
export const assignProfiles = async (userId: string, profileIds: number[]): Promise<void> => {
  await api.put(`/Profile/users/${userId}`, { profileIds });
};

/** Perfis ativos que quem chama pode atribuir (regra "ninguém concede o que não tem"). Policy users.register. */
export const getAssignableProfiles = async (): Promise<Profile[]> =>
  (await api.get("/Profile/atribuiveis")).data;
